import React, { useEffect, useState } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { generateWithEngine, generationError } from '../gmpGeneration';

// Motion
import { motion } from 'framer-motion';

// VK
import { Snackbar } from '@vkontakte/vkui';
import { Icon28ErrorCircleOutline } from '@vkontakte/icons';

// Lottie
import Lottie from 'react-lottie';
import generatingPost from '../lotties/magic_wand.json';
import posts from '../lotties/posts.json'

// Telegram UI
import { AppRoot, Avatar, Badge, Cell, FixedLayout, IconButton, Navigation, Section } from '@telegram-apps/telegram-ui';

import { SimpleCell, Button, Group, Image, Spinner, Div, Text } from '@vkontakte/vkui';
import { Icon16HistoryBackwardOutline, Icon16Stars, Icon16ClockOutline, Icon16WarningTriangleOutline } from '@vkontakte/icons';

const tg = window.Telegram.WebApp;

const PremodePage = ({ activePanel, setActivePanel, setSelectedPostText, setSelectedPremodePost, selectedGroup, premodePosts, activeView, setActiveView, setPremodePosts, isMobile }) => {
    const [loadingScreen, setLoadingScreen] = useState('none');
    const [snackbar, setSnackbar] = useState(null);

    const openError = (text) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)" />}
            >
                {text}
            </Snackbar>,
        );
    };

    const generatingPostOpt = {
        loop: true,
        autoplay: true,
        animationData: generatingPost,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const postsOpt = {
        loop: true,
        autoplay: true,
        animationData: posts,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const optionsPremodeItem = {
        replace: (domNode) => {
            // Удаляем теги <br> и <a>
            if (domNode.type === 'tag' && domNode.name === 'br') {
                return <></>; // Заменяем <br> на пустой фрагмент
            }

            // Для всех допустимых тегов возвращаем их вместе с дочерними элементами
            if (domNode.type === 'tag' && (domNode.name === 'b' || domNode.name === 'i' || domNode.name === 'u' || domNode.name === 'strike')) {
                return domToReact(domNode, optionsPremodeItem); // Оставляем допустимые теги
            }

            // Для всех остальных тегов возвращаем только их дочерние элементы, если они есть
            if (domNode.children && domNode.children.length > 0) {
                return <>{domToReact(domNode.children, optionsPremodeItem)}</>;
            }

            // Возвращаем null для всех остальных недопустимых пустых тегов
            return null;
        }
    };

    const getPremodePosts = async () => {
        const url = `https://api.gmpapp.ru/get_premode?tg_id=${tg.initDataUnsafe.user.id}`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            setPremodePosts(data.items);
            console.los('Posts loaded!')
        } catch (error) {
            console.error('Error while fetching premode posts:', error);
        }
    };

    const generatePost = async (event) => {
        setLoadingScreen('flex');

        try {
            const response = await generateWithEngine('post', {
                tg_id: tg.initDataUnsafe.user.id,
                group_id: selectedGroup.id
            });

            setLoadingScreen('none');
            // Оптимистичное добавление нового поста к локальному списку, если бекенд его возвращает, иначе перекачиваем посты
            if (response.data && response.data.post_id) {
                setPremodePosts(prev => [response.data, ...prev]);
            } else if (response.data && response.data.item) {
                setPremodePosts(prev => [response.data.item, ...prev]);
            } else if (Array.isArray(response.data) && response.data.length > 0) {
                setPremodePosts(prev => [response.data[0], ...prev]);
            } else {
                getPremodePosts();
            }

        } catch (error) {
            setLoadingScreen('none');
            openError(generationError(error));
        }
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
            tg.BackButton.offClick(backButtonHandler);
        };

        const getPremodePosts = async () => {
            const url = `https://api.gmpapp.ru/get_premode?tg_id=${tg.initDataUnsafe.user.id}`;
            try {
                const response = await fetch(url);
                const data = await response.json();
                setPremodePosts(data.items);
                console.log('Posts loaded!')
            } catch (error) {
                console.error('Error while fetching premode posts:', error);
            }
        };

        // Устанавливаем обработчик нажатия на кнопку "Назад" только если activeView равен 'view1'
        if (activePanel === 'posts') {
            tg.BackButton.show();
            tg.MainButton.hide();
            tg.BackButton.onClick(backButtonHandler);
        } else {
            tg.BackButton.offClick(backButtonHandler); // Удаляем обработчик, если activeView не 'view1'
        }

        // Очистка эффекта
        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    const [messageIndex, setMessageIndex] = useState(0);
    const [dots, setDots] = useState('');
    const messages = [
        "Ищем новости",
        "Выбираем лучшую",
        "Делаем рерайт",
        "Генерируем пост"
    ];

    useEffect(() => {
        if (!loadingScreen) return; // Если loadingScreen не true, ничего не делаем

        const interval = setInterval(() => {
            if (messageIndex < messages.length - 1) {
                setMessageIndex(prevIndex => prevIndex + 1);
            }
        }, 2500);

        return () => clearInterval(interval); // Очистка интервала при размонтировании компонента
    }, [loadingScreen, messageIndex]);

    useEffect(() => {
        if (!loadingScreen) return; // Если loadingScreen не true, ничего не делаем

        const dotInterval = setInterval(() => {
            setDots(prevDots => {
                if (prevDots.length < 3) {
                    return prevDots + '.';
                } else {
                    return '';
                }
            });
        }, 500); // Измените интервал, если нужно

        return () => clearInterval(dotInterval); // Очистка интервала при размонтировании компонента
    }, [loadingScreen, messageIndex]);

    return (
        <Group className="premodelist" style={isMobile ? { marginTop: "calc(var(--tg-content-safe-area-inset-top) + 20px)" } : null}>
            <div className="overlaySpinner" style={{ display: loadingScreen }}>
                <Lottie
                    isClickToPauseDisabled={true}
                    options={generatingPostOpt}
                    height={150}
                    width={150}
                />
                <motion.div
                    style={{ paddingTop: "40px" }}
                    key={messageIndex}
                    initial={{ opacity: 0, y: -20 }} // Начальная анимация
                    animate={{ opacity: 1, y: 0 }} // Конечная анимация
                    exit={{ opacity: 0, y: 20 }} // Анимация выхода
                    transition={{ duration: 1 }} // Длительность анимации
                >
                    <span>{messages[messageIndex]}{dots}</span>
                </motion.div>
            </div>

            <div className="premodelistItem">
                {premodePosts.filter(post => selectedGroup === null || post.id === selectedGroup.id).length === 0 && (
                    <Div className="VKlogin">
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={postsOpt}
                            height={150}
                            width={150}
                        />
                        <Text>Здесь будут находиться посты, которые сгенерируются за назначенное время в параметрах. Чтобы получить пост прямо сейчас, нажми на кнопку «Сгенерировать пост» ниже </Text>
                    </Div>
                )}
                {premodePosts
                    .filter(post => selectedGroup === null || post.id === selectedGroup.id)
                    .sort((a, b) => b.time.localeCompare(a.time)) // здесь добавлена обратная сортировка
                    .map((post) => (
                        <SimpleCell
                            className={
                                !/\d/.test(post.time)
                                    ? 'timerAwait'
                                    : (post.media.length >= 1 && (post.text_length + (post.post_original ? (post.article.length + 6) : 0)) >= 1025) ||
                                        (post.media.length === 0 && (post.text_length + (post.post_original ? (post.article.length + 6) : 0)) >= 4097)
                                        ? 'lengthLimit'
                                        : ''
                            }
                            onClick={() => {
                                setSelectedPremodePost(post);
                                setSelectedPostText(post.text);
                                setActivePanel('post');
                                console.log(selectedGroup);
                            }}
                            subtitle={
                                !/\d/.test(post.time)
                                    ? "Установите время выхода поста"
                                    : (post.media.length >= 1 && (post.text_length + (post.post_original ? (post.article.length + 6) : 0)) >= 1025) ||
                                        (post.media.length === 0 && (post.text_length + (post.post_original ? (post.article.length + 6) : 0)) >= 4097)
                                        ? "Сократите текст поста"
                                        : `Выйдет в ${post.time} по МСК (GMT+3)`
                            }
                            before={
                                <Image
                                    src={
                                        post.media && post.media.length > 0
                                            ? (/\.(mp4|mov|webm)$/i.test(post.media[0])
                                                ? `${post.media[0]}.jpg`
                                                : post.media[0])
                                            : 'https://gmpapp.ru/images/no_image.jpg'
                                    }
                                />
                            }
                            after={
                                <div style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: "12px", paddingRight: "4px" }}>
                                    {
                                        !/\d/.test(post.time)
                                            ? <Icon16HistoryBackwardOutline width={16} height={16} />
                                            : (post.media.length >= 1 && post.text_length >= 1024) ||
                                                (post.media.length === 0 && post.text_length >= 4096)
                                                ? <Icon16WarningTriangleOutline width={16} height={16} />
                                                : <Icon16ClockOutline width={16} height={16} />
                                    }
                                </div>
                            }
                        >
                            {parse(post.text, optionsPremodeItem)}
                        </SimpleCell>
                    ))}
            </div>
            {snackbar}
            
            <FixedLayout vertical="bottom" style={{ padding: 16 }}>
                <Button
                    before={<Icon16Stars />}
                    tyle={{ flexGrow: '0' }}
                    stretched
                    size="l"
                    appearance="secondary"
                    onClick={generatePost}
                    className="generatePostButton"
                >
                    Сгенерировать пост
                </Button>
            </FixedLayout>
        </Group>
    );
};

export default PremodePage;
